/*
 *   Copyright (c) 2026 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import { GetMyTicketsService, IGetMyTicketsMethods } from "./components";

export type TicketsPageAgent = IGetMyTicketsMethods;

const getPlugins = () => {
  return [new GetMyTicketsService()];
};

export const getAgent = () => {
  return createAgent<TicketsPageAgent>({
    plugins: getPlugins(),
  });
};
